import { FastshiftDashboardPageTemplate } from "../../../templates/fastshift/dashboard/fastshift-dashboard-page/src";

export const FastshiftDashboardPage = () => <FastshiftDashboardPageTemplate />;
